import ARROW_LEFT from 'assets/images/arrow_left_gray.png'
import LOGO from 'assets/images/logo_square.png'

const Images = {ARROW_LEFT, LOGO}
export default Images
